import apiClient from './client'
import API from '@/api/API'

export interface SkillListItem {
  id: string
  slug: string
  name: string
  description?: string
  skillType: string
  managementMode: string
  enabled: boolean
  editable: boolean
  isSystem: boolean
}

export interface SkillExecutionConfig {
  skillId?: string
  executor: string
  inputMode: string
  outputMode: string
  modelPolicy: string
  fixedModelId?: string
  applyDefault: boolean
  persistOutput: boolean
  maxTokens: number
  executionConfig: Record<string, unknown>
}

export interface SkillExecuteResult {
  output: string
  skill_id: string
  skill_revision: number
  model_id?: string
  locale: string
  insight_id?: string
  insight_type?: string
  run_id?: string
}

export const skillsApi = {
  list: async () => {
    const response = await apiClient.get<SkillListItem[]>(`${API.skills.base}`)
    return response.data
  },

  get: async (skillId: string) => {
    const response = await apiClient.get<SkillListItem>(`${API.skills.base}/${skillId}`)
    return response.data
  },

  execute: async (skillId: string, data: {
    input_text?: string
    source_id?: string
    model_id?: string
    locale?: string
    persist?: boolean
  }) => {
    const response = await apiClient.post<SkillExecuteResult>(
      `${API.skills.base}/${skillId}/execute`,
      data
    )
    return response.data
  },

  playground: async (skillId: string, data: {
    input_text: string
    source_id?: string
    model_id?: string
    locale?: string
    save_as_insight?: boolean
  }) => {
    const response = await apiClient.post<SkillExecuteResult>(
      `${API.skills.base}/${skillId}/playground`,
      data
    )
    return response.data
  },
}
